export const stats = [
  {
    value: "200K+",
    label: "Tech Talents",
    description: "African tech talents across multiple technology stacks",
    dark: true,
  },
  {
    value: "15K+",
    label: "Professional Trained",
    description: "Several thousand professionals trained and upskilled",
    dark: false,
  },
  {
    value: "50+",
    label: "Clients",
    description: "Startups and enterprise clients served across different industries",
    dark: false,
  },
  {
    value: "15+",
    label: "Project Delivered",
    description: "Multiple technology projects successfully delivered",
    dark: false,
  },
];
